import type { TechnicalDrawingFormFields } from './drawing-types';

export function drawingDefaultValues(): TechnicalDrawingFormFields {
    return {
        ElectricalProjectFileId: null,
        Name: null,
        Description: null,
        Location: null,
        IsDrawingPresent: null,
    };
}
